import { getEnv } from '@luna/env';
import { request } from '@luna/api';
import type { RetailFeatures } from '@retail/gatekeeper';
import type { FlagsServicePayload } from '@luna/gatekeeper';
import { fetchFeatureFlags } from '@luna/gatekeeper';
import { uuid } from '@luna/utils';
import { getFeatureConfig } from '@luna/feature-config';

const featureFlagsLoader = (): Promise<FlagsServicePayload> => {
    const headers: Record<string, string> = {
        'X-Application-Type': 'george-web',
    };
    if (getFeatureConfig((f) => f.base.sendRequestId)) {
        headers['X-REQUEST-ID'] = uuid();
    }
    return request<FlagsServicePayload>(`${getEnv().apiGatewayUrl}nfotc/public/flags`, {
        headers,
    });
};

export function fetchGatekeeperFeatures(): Promise<Partial<RetailFeatures>> {
    return fetchFeatureFlags(featureFlagsLoader);
}
